import React from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { ReactComponent as Lock } from "../images/lock.svg";
import { ReactComponent as LockOpen } from "../images/lock-open.svg";

import "./LockIcon.css";
import UserNavi from "./UserNavi";

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = () => ({});

function LockIcon(props) {
  const [userNaviOpen, setUserNaviOpen] = React.useState(false);
  const navigate = useNavigate();
  const logged = props.loginState.token;

  const naviClicked = () => {
    if (logged) {
      setUserNaviOpen((open) => !open);
    } else {
      navigate("/login");
    }
  };

  const hideNavi = () => {
    setUserNaviOpen(false);
  };

  return (
    <li className="lock">
      <button
        id="login-btn"
        aria-label="Avaa kirjautumisvalikko"
        onClick={naviClicked}
        title="Kirjaudu sisään"
      >
        {logged ? <LockOpen /> : <Lock />}
      </button>
      {userNaviOpen ? <UserNavi hideNavi={hideNavi} /> : null}
    </li>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LockIcon);
